export const homepageTemplates = {
  default: {
    id: 'default',
    name: 'Pasar MIKRO',
    description: 'Semua widget aktif',
    layout: {
      widgets: {
        attendance: {
          enabled: true,
          order: 1,
          gridSize: { xs: 12, md: 6, lg: 4 },
        },
        event: { enabled: true, order: 2, gridSize: { xs: 12, md: 6, lg: 4 } },
        whistleblowing: {
          enabled: true,
          order: 3,
          gridSize: { xs: 12, md: 6, lg: 4 },
        },
        cashflow: {
          enabled: true,
          order: 4,
          gridSize: { xs: 12, md: 12, lg: 12 },
        },
      },
    },
  },

  minimal: {
    id: 'minimal',
    name: 'Findora',
    description: 'Widget penting saja',
    layout: {
      widgets: {
        attendance: { enabled: true, order: 1, gridSize: { xs: 12, md: 6 } },
        event: { enabled: false, order: 2, gridSize: { xs: 12, md: 6 } },
        whistleblowing: {
          enabled: true,
          order: 2,
          gridSize: { xs: 12, md: 6 },
        },
        cashflow: { enabled: false, order: 3, gridSize: { xs: 12, md: 12 } },
      },
    },
  },

  transaction: {
    id: 'transaction',
    name: 'AP2HI',
    description: 'Fokus transaksi',
    layout: {
      widgets: {
        attendance: { enabled: false, order: 1, gridSize: { xs: 12, md: 6 } },
        event: { enabled: false, order: 2, gridSize: { xs: 12, md: 6 } },
        whistleblowing: {
          enabled: false,
          order: 3,
          gridSize: { xs: 12, md: 6 },
        },
        cashflow: {
          enabled: true,
          order: 1,
          gridSize: { xs: 12, md: 12, lg: 12 },
        },
      },
    },
  },
}

export const getDefaultTemplate = (userRole, userProfile) => {
  if (userRole === 'admin' || userRole === 'super_admin') {
    return homepageTemplates.default
  }

  if (userProfile?.preferences?.homepageTemplate) {
    return (
      homepageTemplates[userProfile.preferences.homepageTemplate] ||
      homepageTemplates.default
    )
  }

  return homepageTemplates.default
}

export const switchTemplate = (templateId) => {
  const template = homepageTemplates[templateId]
  if (template) {
    localStorage.setItem('homepageTemplate', templateId)
    return template
  }
  return homepageTemplates.default
}

export const getActiveTemplate = () => {
  const savedTemplate = localStorage.getItem('homepageTemplate')
  return homepageTemplates[savedTemplate] || homepageTemplates.default
}
